import type { FC, ReactNode } from 'react';
import { useTheme } from 'styled-components';

import {
  EActionAttribute,
  EColor,
  EFontWeight,
  ETypographyVariant,
  ThemeProps,
  ThemeSpacing,
} from '@core/type';

import { Box } from '../layout/Box';
import { Typography } from '../typography/Typography';
import { Paper } from './Paper';
import { PaperFormProps } from './interface-paper';

const SpacingBox = ({
  children,
  paddingBottom,
}: {
  children: ReactNode;
  paddingBottom?: ThemeSpacing;
}) =>
  children && (
    <Box
      margin={'0px auto'}
      paddingBottom={paddingBottom}
      width={'100%'}
      flexDirection={'column'}
      alignItems={'center'}
      display={'flex'}
    >
      {children}
    </Box>
  );

export const PaperForm: FC<PaperFormProps> = ({
  title,
  subtitle,
  children,
  alert,
  hasElevation: hasElevationProps = true,
  ...paperProps
}: PaperFormProps): JSX.Element => {
  const {
    structure: {
      paper: {
        form: { padding, maxWidth, hasElevation, paddingTop },
      },
    },
  } = useTheme() as ThemeProps;

  return (
    <Paper
      hasElevation={hasElevationProps && hasElevation}
      padding={padding}
      maxWidth={maxWidth}
      {...paperProps}
    >
      {title &&
        (typeof title === 'string' ? (
          <SpacingBox paddingBottom={'8px'}>
            <Typography
              as={EActionAttribute.H3}
              variant={ETypographyVariant.H4}
              color={EColor.PRIMARY}
              textAlign={'center'}
            >
              {title}
            </Typography>
          </SpacingBox>
        ) : (
          title
        ))}
      {subtitle && (
        <SpacingBox>
          <Box>
            <Typography
              variant={ETypographyVariant.BODY3}
              fontWeight={EFontWeight.REGULAR}
              textAlign={'center'}
            >
              {subtitle}
            </Typography>
          </Box>
        </SpacingBox>
      )}
      {alert && <SpacingBox>{alert}</SpacingBox>}
      {children && (
        <Box
          margin={'0px auto'}
          paddingTop={paddingTop}
          width={'100%'}
          flexDirection={'column'}
          alignItems={'center'}
          display={'flex'}
          maxWidth={'364px'}
        >
          {children}
        </Box>
      )}
    </Paper>
  );
};
